/**
 * SetLogo — 세트 로고 자리.
 *
 * **아직 이미지가 없다** (2026-08-14). 세트 로고 에셋이 정해지기 전이라 자리만
 * 잡아 두고 'SET LOGO' 라고 적힌 빈 판을 그린다. 에셋이 오면 DummySet 에
 * `logoUrl` 을 채우고 호출부는 그대로 두면 된다 — 카드 아트(CardArt)와 같은
 * 구조다.
 *
 * ⚠ 자리표시자에 세트 이름을 적지 않는다. 이름은 바로 아래 줄이 이미 말하고 있어
 *   같은 글자가 두 번 나오면 로고가 아니라 제목이 두 개인 것처럼 읽힌다.
 *
 * 비율은 가로로 긴 3:1 이다. 포켓몬 세트 로고는 대부분 가로형 워드마크라
 * 카드 비율(63:88)을 쓰면 위아래가 크게 빈다.
 */
import styles from "./SetLogo.module.css";

export interface SetLogoProps {
  /** 세트 로고 이미지. 없으면 'SET LOGO' 자리표시자가 보인다 */
  logoUrl?: string;
  /**
   * 스크린리더용 이름. 세트명이 옆에 이미 있으면 생략한다 —
   * 그 경우 장식이므로 aria-hidden 으로 빠진다.
   */
  ariaLabel?: string;
}

export default function SetLogo({ logoUrl, ariaLabel }: SetLogoProps) {
  return (
    <span
      className={styles.base}
      role={ariaLabel ? "img" : undefined}
      aria-label={ariaLabel}
      aria-hidden={ariaLabel ? undefined : true}
    >
      {logoUrl ? (
        <img className={styles.art} src={logoUrl} alt="" loading="lazy" decoding="async" />
      ) : (
        <span className={styles.placeholder}>SET LOGO</span>
      )}
    </span>
  );
}
